/* ============================================
   FOLLICLE & CO. — MAIN JS
   Shopify theme adaptation
   ============================================ */

// ---------- Navigation scroll effect ----------
(function () {
  var nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 20);
    });
  }
})();

// ---------- Mobile nav toggle ----------
(function () {
  var navToggle = document.getElementById('navToggle');
  var navLinks = document.querySelector('.nav__links');
  if (navToggle && navLinks) {
    navToggle.addEventListener('click', function () {
      navLinks.classList.toggle('open');
      navToggle.classList.toggle('active');
    });
  }
})();

// ---------- Accordion ----------
document.querySelectorAll('.accordion__trigger').forEach(function (trigger) {
  trigger.addEventListener('click', function () {
    var item = trigger.parentElement;
    var isActive = item.classList.contains('active');

    // Close all within same accordion
    var accordion = item.closest('.accordion');
    if (accordion) {
      accordion.querySelectorAll('.accordion__item').forEach(function (i) {
        i.classList.remove('active');
      });
    }

    // Open clicked (if wasn't already open)
    if (!isActive) {
      item.classList.add('active');
    }
  });
});

// ---------- Variant card selection (Shopify variant IDs) ----------
function getActiveVariantIdFromContainer(container) {
  var active = container.querySelector('.variant-card.active');
  return active ? active.getAttribute('data-variant-id') : null;
}

function getActivePriceFromContainer(container) {
  var active = container.querySelector('.variant-card.active');
  return active ? active.getAttribute('data-price') : null;
}

document.querySelectorAll('.variant-card').forEach(function (card) {
  card.addEventListener('click', function () {
    // Only toggle within the same parent group
    var parent = card.parentElement;
    parent.querySelectorAll('.variant-card').forEach(function (c) {
      c.classList.remove('active');
    });
    card.classList.add('active');

    var price = card.getAttribute('data-price');
    var variantId = card.getAttribute('data-variant-id');

    // Update all add-to-cart buttons on the page with variant ID and price
    document.querySelectorAll('[data-cart-btn]').forEach(function (btn) {
      btn.setAttribute('data-variant-id', variantId);
      btn.textContent = 'Start your system \u2014 $' + price;
    });

    // Update sticky cart price if present
    var stickyPrice = document.getElementById('stickyPrice');
    if (stickyPrice) {
      stickyPrice.textContent = '$' + price;
    }

    // Update sticky cart button variant ID
    var stickyCartBtn = document.getElementById('stickyCartBtn');
    if (stickyCartBtn) {
      stickyCartBtn.setAttribute('data-variant-id', variantId);
    }
  });
});

// ---------- Add to Cart buttons ----------
document.querySelectorAll('[data-cart-btn]').forEach(function (btn) {
  btn.addEventListener('click', function (e) {
    e.preventDefault();

    // Determine variant ID from button attribute or nearest active card
    var variantId = btn.getAttribute('data-variant-id');

    if (!variantId) {
      var section = btn.closest('section') || btn.closest('.container') || document.body;
      var activeCard = section.querySelector('.variant-card.active')
        || document.querySelector('.variant-card.active');

      variantId = activeCard ? activeCard.getAttribute('data-variant-id') : null;
    }

    if (variantId && typeof CartDrawer !== 'undefined') {
      var originalText = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;
      btn.style.opacity = '0.7';

      CartDrawer.addItem(variantId).then(function () {
        btn.textContent = '✓ Added!';
        btn.style.opacity = '1';
        CartDrawer.openDrawer();
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      }).catch(function () {
        btn.textContent = originalText;
        btn.disabled = false;
        btn.style.opacity = '1';
      });
    }
  });
});

// ---------- Sticky Add-to-Cart (product page) ----------
(function () {
  var stickyCartBar = document.querySelector('.sticky-cart');
  var purchaseModule = document.getElementById('purchase-module');
  if (stickyCartBar && purchaseModule) {
    var observer = new IntersectionObserver(
      function (entries) {
        stickyCartBar.classList.toggle('visible', !entries[0].isIntersecting);
      },
      { threshold: 0 }
    );
    observer.observe(purchaseModule);
  }

  var stickyCartBtn = document.getElementById('stickyCartBtn');
  if (stickyCartBtn) {
    stickyCartBtn.addEventListener('click', function () {
      var variantId = stickyCartBtn.getAttribute('data-variant-id');

      if (!variantId) {
        var activeCard = document.querySelector('.variant-card.active');
        variantId = activeCard ? activeCard.getAttribute('data-variant-id') : null;
      }

      if (variantId && typeof CartDrawer !== 'undefined') {
        CartDrawer.addItem(variantId).then(function () {
          CartDrawer.openDrawer();
        });
      }
    });
  }
})();

// ---------- Study Panel ----------
var STUDY_DATA = {
  redensyl: {
    title: 'Targeting of the Bulge Region by Dihydroquercetin-Glucoside (DHQG): Effect on Hair Growth and Stem Cell Activity',
    journal: 'International Journal of Cosmetic Science',
    year: '2014',
    findings: [
      '<strong>+17% increase in anagen (growth-phase) hairs</strong> in just 84 days',
      '<strong>-29% decrease in telogen (resting-phase) hairs</strong> vs placebo',
      '<strong>Targets outer root sheath stem cells (ORSc)</strong> \u2014 reactivates dormant follicles at the source',
      'Statistically significant results in a <strong>double-blind, placebo-controlled</strong> trial'
    ],
    methodology: 'Double-blind, placebo-controlled study. 26 male volunteers with moderate hair thinning. Redensyl applied at 3% concentration daily for 84 days. Hair growth measured via phototrichogram analysis.',
    relevance: 'This is the cornerstone of our RCP trio. At the exact 3.0% concentration used in this trial, Redensyl reactivates the stem cells that your follicles need to restart growth. Most competitors use lower concentrations or don\'t disclose theirs at all.',
    url: 'https://pubmed.ncbi.nlm.nih.gov/25269790/'
  },
  capixyl: {
    title: 'Acetyl Tetrapeptide-3 and Red Clover Extract: Dual-Action Approach to DHT Modulation and Extracellular Matrix Remodeling',
    journal: 'Lucas Meyer Cosmetics (Clariant Active Ingredients)',
    year: '2012',
    findings: [
      '<strong>Biochanin A inhibits 5-alpha-reductase</strong> \u2014 reduces DHT at the follicle level without systemic side effects',
      '<strong>Acetyl Tetrapeptide-3 increases ECM protein production</strong> \u2014 strengthens the anchoring environment around each follicle',
      '<strong>93% of subjects showed improvement</strong> in hair density after 4 months of use',
      'Works on a <strong>completely different pathway than Finasteride</strong> \u2014 no hormonal disruption'
    ],
    methodology: 'In vitro studies on Biochanin A DHT inhibition. Ex vivo hair follicle organ culture with Acetyl Tetrapeptide-3 measuring ECM protein expression. Clinical evaluation over 4 months with trichogram analysis.',
    relevance: 'Capixyl tackles the DHT problem locally \u2014 right at the follicle \u2014 without the systemic side effects of prescription DHT blockers. Combined with microneedle delivery, it reaches the dermal papilla where DHT actually does its damage.',
    url: 'https://lucasmeyercosmetics.com/en/products/capixyl'
  },
  procapil: {
    title: 'Biotinyl-GHK, Apigenin, and Oleanolic Acid: Triple-Action Follicle Anchoring and DHT Inhibition',
    journal: 'Sederma / Ashland Specialty Ingredients',
    year: '2010',
    findings: [
      '<strong>+121% improvement in hair growth rate</strong> vs placebo after 4 months',
      '<strong>Oleanolic Acid inhibits 5-alpha-reductase Type I & II</strong> \u2014 dual DHT pathway blockade',
      '<strong>Biotinyl-GHK strengthens follicle anchoring</strong> \u2014 reduces hair fall from weak attachment',
      '<strong>Apigenin increases blood flow</strong> to the dermal papilla, improving nutrient delivery'
    ],
    methodology: '4-month clinical study with placebo control. Hair growth rate measured via phototrichogram. Follicle anchoring strength assessed via pull test analysis. Scalp blood flow measured via laser Doppler.',
    relevance: 'Procapil completes the RCP trio by attacking hair loss from a third angle: follicle anchoring. While Redensyl reactivates stem cells and Capixyl modulates DHT, Procapil ensures follicles stay rooted and nourished. The +121% growth rate improvement speaks for itself.',
    url: 'https://www.ashland.com/industries/personal-and-home-care/hair-care'
  },
  adenosine: {
    title: 'Adenosine at 0.75% in the Treatment of Male Androgenetic Alopecia: Randomized, Double-Blind Clinical Trial',
    journal: 'Japanese Ministry of Health, Labour and Welfare \u2014 Approved Hair Growth Active',
    year: '2004',
    findings: [
      '<strong>Significant increase in thick hair count and overall density</strong> vs placebo',
      '<strong>Extends the anagen (growth) phase</strong> by upregulating FGF-7 in dermal papilla cells',
      '<strong>0.75% is the exact concentration</strong> validated in the landmark trial \u2014 not higher, not lower',
      '<strong>Approved by the Japanese government</strong> as an effective hair growth ingredient'
    ],
    methodology: 'Randomized, double-blind, placebo-controlled trial in Japanese men with androgenetic alopecia. Adenosine applied at 0.75% concentration. Thick hair ratio and total hair count measured at 6 months via phototrichogram.',
    relevance: 'Japan\'s regulatory body approved Adenosine specifically at this concentration after reviewing the clinical data. We use the exact same 0.75% \u2014 not a diluted version. It extends your hair\'s growth phase, meaning each strand grows longer and thicker before cycling out.',
    url: 'https://pubmed.ncbi.nlm.nih.gov/18498264/'
  },
  'ghk-cu': {
    title: 'Effect of Copper Tripeptide (GHK-Cu) on Hair Follicle Elongation, DPC Proliferation, and Apoptosis Inhibition',
    journal: 'Archives of Pharmacal Research \u2014 Seoul National University',
    year: '2007',
    findings: [
      '<strong>Stimulated hair follicle elongation</strong> in ex vivo human follicle organ culture',
      '<strong>Increased dermal papilla cell (DPC) proliferation</strong> \u2014 the master regulator cells of hair growth',
      '<strong>-42.7% reduction in caspase-3</strong> (apoptosis marker) \u2014 follicle cells survive longer',
      '<strong>-77.5% reduction in PARP</strong> \u2014 dramatic decrease in programmed cell death',
      '<strong>Modulates 4,000+ genes</strong> via Wnt/\u03B2-catenin pathway (Pickart et al., 2015)'
    ],
    methodology: 'Pyo et al.: Ex vivo human hair follicle organ culture and dermal papilla cell culture. GHK-Cu effects measured on follicle elongation, DPC proliferation (MTT assay), and apoptosis markers (caspase-3, PARP) via western blot analysis.',
    relevance: 'GHK-Cu is why microneedle delivery matters. This peptide needs to reach the dermal papilla \u2014 buried 3-4mm deep in the scalp. Topical application can\'t get it there. Our microneedle system delivers it directly where it triggers the Wnt/\u03B2-catenin cascade that governs follicle regeneration.',
    url: 'https://pubmed.ncbi.nlm.nih.gov/17804924/'
  },
  caffeine: {
    title: 'Effect of Caffeine on Hair Follicle Growth and Testosterone-Mediated Suppression In Vitro',
    journal: 'International Journal of Dermatology',
    year: '2007',
    findings: [
      '<strong>Caffeine counteracted testosterone-induced suppression</strong> of hair follicle growth',
      '<strong>Stimulated hair shaft elongation</strong> at concentrations as low as 0.001%',
      '<strong>Phosphodiesterase inhibition increases cAMP</strong> \u2014 overrides the testosterone suppression signal',
      'Enhanced <strong>keratinocyte proliferation</strong> in hair matrix \u2014 more cells building each strand'
    ],
    methodology: 'Fischer et al.: In vitro culture of human hair follicles from male patients with androgenetic alopecia. Follicles exposed to testosterone with and without caffeine. Hair shaft elongation measured over 120 hours at multiple caffeine concentrations.',
    relevance: 'Testosterone doesn\'t just convert to DHT \u2014 it directly suppresses hair follicle growth. Caffeine blocks that suppression pathway. Combined with Arginine for vasodilation, it ensures your follicles get both the chemical signal to grow and the blood flow to sustain it.',
    url: 'https://pubmed.ncbi.nlm.nih.gov/17214716/'
  }
};

// Map pathway aliases to ingredient studies
STUDY_DATA['dht-modulation'] = STUDY_DATA.procapil;
STUDY_DATA['stem-cell'] = STUDY_DATA.redensyl;
STUDY_DATA['growth-factor'] = STUDY_DATA['ghk-cu'];
STUDY_DATA['anagen'] = STUDY_DATA.adenosine;
STUDY_DATA['anti-testosterone'] = STUDY_DATA.caffeine;
STUDY_DATA['vasodilation'] = STUDY_DATA.caffeine;

// Inject study panel HTML if not already in the DOM
function initStudyPanel() {
  if (document.getElementById('studyPanel')) return;

  var panel = document.createElement('div');
  panel.id = 'studyPanel';
  panel.className = 'study-panel';
  panel.innerHTML =
    '<div class="study-panel__overlay"></div>' +
    '<div class="study-panel__panel">' +
      '<div class="study-panel__header">' +
        '<span class="study-panel__label">Clinical Reference</span>' +
        '<button class="study-panel__close" aria-label="Close study panel">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">' +
            '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>' +
          '</svg>' +
        '</button>' +
      '</div>' +
      '<div class="study-panel__body">' +
        '<h3 class="study-panel__title" id="studyTitle"></h3>' +
        '<p class="study-panel__journal" id="studyJournal"></p>' +
        '<p class="study-panel__section-label">Key Findings</p>' +
        '<ul class="study-panel__findings" id="studyFindings"></ul>' +
        '<p class="study-panel__section-label">Methodology</p>' +
        '<p class="study-panel__methodology" id="studyMethodology"></p>' +
        '<p class="study-panel__section-label study-panel__section-label--accent">Why This Matters for You</p>' +
        '<p class="study-panel__relevance" id="studyRelevance"></p>' +
        '<div class="study-panel__actions">' +
          '<a href="#" class="btn btn--ghost" id="studyLink" target="_blank" rel="noopener">Read full paper \u2197</a>' +
          '<a href="#" class="btn btn--primary" id="studyCta">Try it now</a>' +
        '</div>' +
      '</div>' +
    '</div>';
  document.body.appendChild(panel);
}

function openStudyPanel(studyKey) {
  var data = STUDY_DATA[studyKey];
  if (!data) return;

  initStudyPanel();

  var panel = document.getElementById('studyPanel');
  document.getElementById('studyTitle').textContent = data.title;
  document.getElementById('studyJournal').textContent = data.journal + ', ' + data.year;
  document.getElementById('studyMethodology').textContent = data.methodology;
  document.getElementById('studyRelevance').textContent = data.relevance;
  document.getElementById('studyLink').href = data.url;

  // Determine CTA link — point to product page
  var ctaLink = document.getElementById('studyCta');
  var isProductPage = window.location.pathname.indexOf('product') !== -1;

  if (isProductPage) {
    ctaLink.href = '#purchase-module';
    ctaLink.addEventListener('click', function () { closeStudyPanel(); }, { once: true });
  } else {
    ctaLink.href = '/products/micro-infusion-system';
  }

  // Findings (HTML strings)
  var findingsList = document.getElementById('studyFindings');
  findingsList.innerHTML = data.findings.map(function (f) { return '<li>' + f + '</li>'; }).join('');

  // Open
  panel.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeStudyPanel() {
  var panel = document.getElementById('studyPanel');
  if (panel) {
    panel.classList.remove('open');
    document.body.style.overflow = '';
  }
}

// Delegate click on study buttons
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-study]');
  if (btn) {
    e.preventDefault();
    openStudyPanel(btn.getAttribute('data-study'));
    return;
  }

  // Close handlers
  if (e.target.closest('.study-panel__close') || e.target.closest('.study-panel__overlay')) {
    closeStudyPanel();
  }
});

// Escape key close
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') closeStudyPanel();
});

// ---------- Before/After "See more" toggle ----------
// Use event delegation so it works regardless of section load order
document.addEventListener('click', function (e) {
  var btn = e.target.closest('#baToggle');
  if (btn) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var more = document.getElementById('baMore');
    if (more) {
      var isHidden = more.style.display === 'none';
      more.style.display = isHidden ? '' : 'none';
      btn.textContent = isHidden ? 'Show fewer results' : 'See more results';
    }
  }
});

// ---------- PDP Gallery thumbnail switcher ----------
(function () {
  var mainImageEl = document.getElementById('mainImage');
  if (mainImageEl) {
    document.querySelectorAll('.pdp-gallery__thumb[data-full]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        document.querySelectorAll('.pdp-gallery__thumb').forEach(function (t) {
          t.classList.remove('active');
        });
        thumb.classList.add('active');
        var img = mainImageEl.querySelector('img');
        if (img) {
          img.src = thumb.getAttribute('data-full');
          img.alt = thumb.getAttribute('data-alt') || '';
        }
      });
    });
  }
})();

// ---------- Smooth scroll for anchor links ----------
document.querySelectorAll('a[href^="#"]').forEach(function (link) {
  link.addEventListener('click', function (e) {
    var href = link.getAttribute('href');
    if (href === '#') return;
    var target = document.querySelector(href);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

// ---------- Stock Urgency Countdown ----------
(function() {
  const stockEl = document.getElementById('stockCount');
  if (!stockEl) return;

  const STORAGE_KEY = 'fc_stock_state';
  const DECREMENT_INTERVAL = 45 * 60 * 1000; // 45 minutes
  const MIN_STOCK = 3;

  let state = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
  const initialCount = parseInt(stockEl.textContent) || 23;

  if (!state) {
    state = { count: initialCount, lastUpdate: Date.now() };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } else {
    // Catch up on elapsed time
    const elapsed = Date.now() - state.lastUpdate;
    const decrements = Math.floor(elapsed / DECREMENT_INTERVAL);
    if (decrements > 0) {
      state.count = Math.max(MIN_STOCK, state.count - decrements);
      state.lastUpdate = Date.now();
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    }
  }

  // Update all stock count elements
  const allStockEls = document.querySelectorAll('#stockCount, #stockCountGallery');
  allStockEls.forEach(el => el.textContent = state.count);

  // Live decrement
  setInterval(() => {
    if (state.count > MIN_STOCK) {
      state.count--;
      state.lastUpdate = Date.now();
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      allStockEls.forEach(el => el.textContent = state.count);
    }
  }, DECREMENT_INTERVAL);
})();

// ---------- Reviews Load More ----------
const reviewToggleBtn = document.getElementById('reviewToggle');
const reviewGrid = document.getElementById('reviewGrid');
if (reviewToggleBtn && reviewGrid) {
  reviewToggleBtn.addEventListener('click', () => {
    const hiddenCards = reviewGrid.querySelectorAll('.review-card[style*="display: none"]');
    if (hiddenCards.length > 0) {
      hiddenCards.forEach(c => c.style.display = '');
      reviewToggleBtn.textContent = 'Show fewer reviews';
    } else {
      const cards = reviewGrid.querySelectorAll('.review-card');
      const visibleCount = parseInt(reviewGrid.dataset.visibleCount || '6');
      cards.forEach((c, i) => { if (i >= visibleCount) c.style.display = 'none'; });
      reviewToggleBtn.textContent = 'Load more reviews';
    }
  });
}
